import { observer } from 'mobx-react-lite'
import { CollapseWithIcon } from 'shared/ui'
import { type Integration } from 'entities/Integrations'
import { useEntitiesContext } from 'entities/EntitiesExport'
import sharedStyles from 'pages/settings/pages/integrations/pages/integrationSettings/ui/styles.module.scss'
import { useIntegrationStoreMemo } from 'pages/settings/pages/integrations/pages/integrationSettings/hooks/useIntegrationStoreMemo'
import { IntegrationIntercomSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationIntercomSettings/store/IntegrationIntercomSettingsStore'
import { CollapseIntegrationSettingsTimeline } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/CollapseIntegrationSettingsTimeline/CollapseIntegrationSettingsTimeline'
import { IntegrationIntercomSettingsSync } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationIntercomSettings/ui/IntegrationIntercomSettingsSync/IntegrationIntercomSettingsSync'
import { IntegrationIntercomConnectInbox } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationIntercomSettings/ui/IntegrationIntercomConnectInbox/IntegrationIntercomConnectInbox'

type IIntegrationIntercomSettingsProps = {
  integration: Integration
}

export const IntegrationIntercomSettings = observer(
  ({ integration }: IIntegrationIntercomSettingsProps) => {
    const entities = useEntitiesContext()
    const { collapseStore, syncStore, timelineStore } = useIntegrationStoreMemo(
      IntegrationIntercomSettingsStore,
      integration,
      entities
    )

    return (
      <div>
        <CollapseWithIcon
          opened={collapseStore.opened('inboxConnect')}
          onClick={collapseStore.onToggle('inboxConnect')}
          icon={'inbox'}
          title={'Connect Salesmsg inboxes to Intercom'}
          label={'Select the Salesmsg inboxes you want to manage from Intercom'}
          headerClassName={sharedStyles.collapseWithIcon}
        >
          <IntegrationIntercomConnectInbox integration={integration} />
        </CollapseWithIcon>
        <CollapseWithIcon
          opened={collapseStore.opened('sync')}
          onClick={collapseStore.onToggle('sync')}
          icon={'arrowHorizontalOutline'}
          title={'Contact syncing'}
          label={syncStore.getLabel}
          headerClassName={sharedStyles.collapseWithIcon}
        >
          <IntegrationIntercomSettingsSync store={syncStore} />
        </CollapseWithIcon>
        <CollapseIntegrationSettingsTimeline
          collapseStore={collapseStore}
          name={integration.name}
          dailyBundles={timelineStore.dailyBundles1_0}
          onDailyBundlesToggle={timelineStore.onDailyBundlesToggle1_0}
        />
      </div>
    )
  }
)
